// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BETypeElement } from './BETypeElement';
import { BEComponent } from './BEComponent';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 业务异常 实体类
 * 业务异常
 */
export class BEException extends BETypeElement {
  /** 编号 : 异常编号，不超过5位 */
  private _code: string;

  /** 设置：编号 */
  public get code() {
    return this._code;
  }

  /** 获取：编号 */
  public set code(value: string) {
    this._code = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  constructor() {
    super();
    this._code = '';
    this._component_ID = '';
    this._component = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BEException, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.code = element.code;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.code = json.Code;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Code = this.code;
    json.Component_ID = this.component_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'code', '编号', EnumDataType.String, this.code, true, '异常编号，不超过5位', '', '');
    return context;
  }

  static Create(json: any): BEException {
    const bEException = new BEException();
    bEException.Deserialize(json);
    bEException.json = json;
    return bEException;
  }
}
